export default "__VITE_ASSET__DMZ1G1FZ__"